export default __webpack_public_path__ + "static/media/default_user.c8dc184f.png";